// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationIT from './locales/it/translation.json';
import translationES from './locales/es/translation.json';
import translationTI from './locales/ti/translation.json';
import translationAM from './locales/am/translation.json';

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  it: { translation: translationIT },
  es: { translation: translationES },
  ti: { translation: translationTI },
  am: { translation: translationAM },
};

// Récupérer la langue depuis localStorage ou utiliser 'en' par défaut
const savedLanguage = localStorage.getItem('app_language') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Fonction pour changer la langue et la persister
export const changeLanguage = (lng: string) => {
  localStorage.setItem('app_language', lng);
  i18n.changeLanguage(lng);
};

export default i18n;
